import { Stack, Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';
import { ScreenReaderPrice } from '@eti/components';
import CaretButtonWithDrawer from '../../common/CaretButtonWithDrawer';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import PriceSpecification from './price-specification/PriceSpecification';

const PaymentDrawerButton = () => {
  const { t } = useTranslation();
  const { totalPriceIncludingAddOnOrders } = useOrderDetails();

  return (
    <CaretButtonWithDrawer
      dataTestId="payment-info"
      drawerContent={<PriceSpecification />}
      drawerTitle={t('OrderDetails.Payment.Overview.Header')}
      snowplow={{
        category: 'Overview',
        label: 'VIEW_RECEIPT',
      }}
    >
      <Stack spacing={4}>
        <Text data-testid="payment-info-title" variant={textVariants._16_BOLD}>
          {t('OrderDetails.Payment.Overview.TotalAmount.Label')}
        </Text>
        <div aria-hidden data-testid="order-total-price">
          {priceUtil.formatPrice(totalPriceIncludingAddOnOrders)}
        </div>
        <ScreenReaderPrice price={priceUtil.formatPrice(totalPriceIncludingAddOnOrders)} />
      </Stack>
    </CaretButtonWithDrawer>
  );
};

export default PaymentDrawerButton;
